import React, { useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import AOS from "aos";
import { jwtDecode } from "jwt-decode";
import { useDispatch, useSelector } from 'react-redux';
import { getHomeSevenSecData } from '../../../Redux/action/MasterAction';
import Aos from 'aos';

const host = process.env.REACT_APP_API_SERVER
const ConnectWithUs = () => {
   

    const navigate = useNavigate();

    const handleNavigation = () => {
        const token = localStorage.getItem('student-token')
        if (token) {
            const decoded = jwtDecode(token);

            if (decoded?.user?.id) {
                navigate('/student/dashboard')
            }
            else {
                navigate('/login', { state: { user: 'student' } })
            }
        }
        else {
            navigate('/login', { state: { user: 'student' } })
        }

    }

    const dispatch = useDispatch();

    const {
        loadingHomeSevenSecDataApi,
    HomeSevenSecDataApiData,
    HomeSevenSecDataApiError,

    } = useSelector(state => state?.MasterReducer);

    useEffect(() => {
        dispatch(getHomeSevenSecData())
       
    }, []);

    useEffect(function () {
        Aos.init({ duration: 1000 });
      }, []);

    return (
        <section className="responsive-section">
            <div className="responsive-container" data-aos="fade-up">
                <div className="content-wrapper">
                    <div className="padding-standard">
                        <div className="inner-container">
                            <div className="grid-layout">
                                <div className="image-wrapper">
                                    <div
                                        className="course-box"
                                       
                                    >
                                        <div className="product">
                                            <div className="product-img">
                                                <a >
                                                    <img
                                                        className="img-fluid"
                                                        alt=""
                                                        src={`${host}${HomeSevenSecDataApiData?.home_section_seven_main_image}`}
                                                        width={600}
                                                        height={300}
                                                    />
                                                </a>
                                            </div>
                                            <div className="product-content">
                                                <h3 className="title">
                                                    <a >{HomeSevenSecDataApiData?.home_section_seven_main_image_name}</a>
                                                </h3>
                                                <div className="author-info">
                                                    <div className="author-name">{HomeSevenSecDataApiData?.home_section_seven_main_image_designation}</div>
                                                </div>
                                                <div className="rating">
                                                    <i className="fas fa-star filled ms-1" />
                                                    <i className="fas fa-star filled ms-1" />
                                                    <i className="fas fa-star filled ms-1" />
                                                    <i className="fas fa-star filled ms-1" />
                                                    <i className="fas fa-star filled ms-1" />
                                                    <span className="d-inline-block average-rating ms-1">
                                                        {HomeSevenSecDataApiData?.home_section_seven_main_image_rating}
                                                    </span>
                                                </div>
                                                <div className="author-country">
                                                    <p className="mb-0">
                                                        <i className="fe fe-map-pin" /> {HomeSevenSecDataApiData?.home_section_seven_main_image_location}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="content-area">
                                    <div className="content-title">
                                        <h2>{HomeSevenSecDataApiData?.home_section_seven_title}</h2>
                                    </div>
                                    <p className="text-large">
                                        {HomeSevenSecDataApiData?.home_section_seven_subtitle}
                                    </p>
                                    <div className="features-group">
                                        <div className="feature-item">
                                            <img
                                                src={`${host}${HomeSevenSecDataApiData?.home_section_seven_para_one_image}`}
                                                alt="Headphones Icon"
                                                className="feature-icons me-2"
                                            />
                                            <div className="feature-content">
                                                <h3>{HomeSevenSecDataApiData?.home_section_seven_para_one_title}</h3>
                                                <p>
                                                    {HomeSevenSecDataApiData?.home_section_seven_para_one_subtitle}
                                                </p>
                                            </div>
                                        </div>
                                        <div className="feature-item">
                                            <img
                                                src={`${host}${HomeSevenSecDataApiData?.home_section_seven_para_two_image}`}
                                                alt="Signpost Icon"
                                                className="feature-icons me-2"
                                            />
                                            <div className="feature-content">
                                                <h3>{HomeSevenSecDataApiData?.home_section_seven_para_two_title}</h3>
                                                <p>
                                                    {HomeSevenSecDataApiData?.home_section_seven_para_two_subtitle}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="cta-button">
                                        <a onClick={handleNavigation} className="btn btn-primary join">
                                            Connect With Us
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ConnectWithUs